import { useFormContext } from 'react-hook-form';

import { Flex, HStack, Radio, RadioGroup, Typography } from 'shared';

const effectivenessRates = ['1', '2', '3', '4', '5'];

export const SessionsFormCoachingToolsEffectivenessRate = ({
  formKey,
  currentRate,
}: {
  formKey: string;
  currentRate: string;
}) => {
  const { setValue } = useFormContext();

  const onChange = (newValue: string) => {
    setValue(`${formKey}.toolEffectivenessRate`, newValue, {
      shouldDirty: false,
    });
  };

  return (
    <Flex flexDirection="column" alignItems="center" gap="var(--spacing04)">
      <Typography type="body" fontWeight="medium" color="black">
        HDE Perceived Rate of Effectiveness
      </Typography>
      <Typography type="meta" color="gray">
        On a scale of 1 - 5, rate how effective this HDE Module was for this
        participant.
      </Typography>

      <RadioGroup
        value={currentRate}
        onValueChange={({ value: newValue }: { value: string }) =>
          onChange(newValue)
        }
        data-testid="session-tool-rate-group"
      >
        <HStack gap="var(--spacing06)">
          {effectivenessRates.map((rate) => (
            <Flex
              key={rate}
              flexDirection="column"
              alignItems="center"
              gap="var(--spacing02)"
            >
              <Radio value={rate} data-testid="session-tool-rate-btn" />
              <Typography color="black">{rate}</Typography>
            </Flex>
          ))}
        </HStack>
      </RadioGroup>
    </Flex>
  );
};
